import React, { useEffect } from "react";
import Tippy from "@tippyjs/react";
import { useTranslation } from "react-i18next";

import Paper from "@/components/paper/Paper";
import { checkSupression } from "@/utils/index";
import { properties } from "@/testData/companyProfile";
import { startAfterAPIresponse } from "@/app/pages/companyProfile/overview/Helper";
import { usePageURL } from "@/shared/customHooks";
import CompanyInfo from "./CompanyInfo";
import CompanySnapshot from "./CompanySnapshot";

// I REQUEST NOT TO REMOVE ANY COMMENTED CODE, AS THOSE WILL BE USED LATER ON

const Overview = ({ props, countryCode }): JSX.Element => {
  const { t } = useTranslation();
  const { dunsNumber } = usePageURL();
  const { encryptedDuns, esgContactUsHrefUrl, esgIndustryAverage, esgRank, esgRankingHrefUrl, magentoCartAddDomain, magentoCartAddEndpoint, magentoCartDisplayName, magentoCartServletPath, primaryName} = props;
  const esgData = { encryptedDuns, esgContactUsHrefUrl, esgIndustryAverage, esgRank, esgRankingHrefUrl, magentoCartAddDomain, magentoCartAddEndpoint, magentoCartDisplayName, magentoCartServletPath, primaryName};

  useEffect(() => {
    startAfterAPIresponse();
  }, []);

  // Print friendly view
  const print = (ev) => {
    ev.preventDefault();
    window.print()
  }


  const buttonAction = () => {
    let redirection = "";
    if (countryCode == "de" || countryCode == "at") {
      redirection = `${t(
        "companyProfile.financial.getDandBCreditLink"
      )}${dunsNumber}`;
    } else if(countryCode === "us") {
      redirection = `${t("companyProfile.overview.revenueBtnRedirectLink")}`;
    } else {
      redirection = `${t("companyProfile.financial.getDandBCreditLink")}`;
    }
    window.location.href = redirection;
  };

  const financialItems = [];
  if (props.formattedRevenue) {
    financialItems.push(
      <div key="revenue">
        <span
          className="company_data_point company-profile-text"
          name="revenue_in_us_dollar"
        >
          <label>{properties.revenue_label}:&nbsp;</label>
          <span>{checkSupression(props.formattedRevenue, {buttonLabel: t("companyProfile.overview.revenueBtnLabel"), text: t("companyProfile.overview.revenuePopupDescription"), type: 'revenue', buttonAction: buttonAction})}</span>
          {props.revenueReliability && (
            <Tippy
              theme="dnbtooltip"
              className="reliability-tag-tool-tip"
              content={t(`companyProfile.overview.reliabilityDefinitionSales${props.revenueReliability}`)}
            >
              <span className="reliability-tag">
                <span className="reliability-tag-icon"></span>
                <span className="reliability-tag-label">
                  {props.revenueReliability}
                </span>
              </span>
            </Tippy>
          )}
        </span>
      </div>
    );
  }
  if (props.showSalesGrowthRate) {
    financialItems.push(
      <div key="sales-growth">
        <span
          className="company_data_point company-profile-text"
          name="sales_growth_percentage"
        >
          <label>{properties.sales_growth_label}:&nbsp;</label>
          <span>{props.salesGrowthPercent}% </span>
        </span>
      </div>
    );
  }
  if (props.showNetGrowthRate) {
    financialItems.push(
      <div key="net-income-growth">
        <span
          className="company_data_point company-profile-text"
          name="net_income_growth_percentage"
        >
          <label>{properties.net_income_growth_label}:&nbsp;</label>
          <span>
            {props.netIncomeGrowthPercent}%
            {/* {properties.growth_percentage_postfix} */}
          </span>
        </span>
      </div>
    );
  }
  if (props.assets) {
    financialItems.push(
      <div key="assets">
        <span className="company_data_point company-profile-text" name="company_assets">
          <label>{properties.assets_label}:&nbsp;</label>
          <span>{checkSupression(props.assets)}</span>
        </span>
      </div>
    );
  }
  if (props.fiscalYearEnd) {
    financialItems.push(
      <div key="fiscal-year-end">
        <span className="company_data_point company-profile-text" name="fiscal_year_end">
          <label>{properties.fiscal_year_end_label}:&nbsp;</label>
          <span>{checkSupression(props.fiscalYearEnd)}</span>
        </span>
      </div>
    );
  }

  return (
    <>
      <a className="anchor" data-name="overview-anchor" href="/overview">
        <span className="display-hidden">Overview</span>
      </a>
      <Paper title={t("companyProfile.overview.overviewLocalized")}>
        <div className="company_profile_overview_body">
          <div className="row">
            <CompanyInfo props={props} countryCode={countryCode} />
            <CompanySnapshot props={props} countryCode={countryCode} financialItems={financialItems} esgData={esgData} print={print} buttonAction={buttonAction} />
          </div>
        </div>
      </Paper>
    </>
  );
};

export default Overview;
